// extracted by mini-css-extract-plugin
export default {"productGallery":"nL-z","inQuickShop":"oL-z"};